export const roles = {
    create: {
        url: 'role/add',
        method: 'POST',
        data: null
    },
    update: {
        url: 'role/update/',
        method: 'PUT',
        id: null,
        data: null
    },
    get: {
        url: 'role/get',
        method: 'GET',
        id: null,
        params: null
    },
    delete: {
        url: 'role/delete/',
        method: 'DELETE',
        id: null
    }
}
